/**
 * Save a fetched file (the fetch carried an Authorization or research header, so a plain link
 * cannot be used). The object URL is revoked once the browser has taken the file.
 */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
}

/**
 * The file name from a Content-Disposition header (filename*=UTF-8''… or filename="…"), reduced
 * to safe characters; `fallback` when absent.
 */
export function filenameFromDisposition(header: string | null, fallback: string): string {
  if (!header) return fallback;
  let name: string | null = null;
  const star = /filename\*\s*=\s*(?:UTF-8|utf-8)''([^;]+)/.exec(header);
  if (star?.[1]) {
    try {
      name = decodeURIComponent(star[1].trim());
    } catch {
      name = null;
    }
  }
  if (!name) {
    const plain = /filename\s*=\s*"?([^";]+)"?/.exec(header);
    name = plain?.[1]?.trim() ?? null;
  }
  if (!name) return fallback;
  const safe = name.replace(/[^\w.\-]+/g, '_').replace(/^\.+/, '');
  return safe.length > 0 ? safe.slice(0, 120) : fallback;
}
